export default [
  {
    uid: 'problem-1',
    label: 'Quantitative data stored in multiple places',
    description: 'ACORNS stores all data in a database specifically designed for environmental applications. This reduces risk of error for data entry and improves version control. Data are then available for reports, analysis, export, and integration with other data.',
    img: null,
    route: null,
    tags: ['acorns','problem']
  },
  {
    uid: 'problem-2',
    label: 'Spatial data is stored in a separate application (eg. ArcInfo) and not directly linked to other project data',
    description: 'Spatial data for the project is stored as layers within ACORNS geodatabase and directly linked to all other project data. Layers are accessible for download and editing by 3rd party applications like ArcInfo.',
    img: null,
    route: null,
    tags: ['acorns','problem']
  },
  {
    uid: 'problem-3',
    label: 'Images are stored on a hard drive or other application such as Dropbox separate from quantitative or other project data',
    description: ' Images are uploaded processed for geo and other tags, and stored in the cloud. Readily available from anywhere and ready to be imported into project reports or other deliverables.',
    img: null,
    tags: ['acorns','problem']
  },
].map( d => ({ ...d, route: d.page ? `/stories/${d.uid}` : null }))
